export enum NODE_ACTION_TYPES {
    GET_MY_NODES_START = 'node/GET_MY_NODES_START',
    GET_MY_NODES_SUCCESS = 'node/GET_MY_NODES_SUCCESS',
    GET_MY_NODES_FAILED = 'node/GET_MY_NODES_FAILED',
    GET_NODE_START = 'node/GET_NODE_START',
    GET_NODE_SUCCESS = 'node/GET_NODE_SUCCESS',
    GET_NODE_FAILED = 'node/GET_NODE_FAILED',
    CLEAR_NODE_SELECTED = 'node/CLEAR_NODE_SELECTED',
    CHANGE_NODE_STATUS_START = 'node/CHANGE_NODE_STATUS_START',
    CHANGE_NODE_STATUS_SUCCESS = 'node/CHANGE_NODE_STATUS_SUCCESS',
    CHANGE_NODE_STATUS_FAILED = 'node/CHANGE_NODE_STATUS_FAILED',
}
